import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
const ImageGrid = ({ images, removeFile }) => {
  // render each image by calling Image component
  const renderImage = (image) => {
    const imageSrc =
      typeof image === "string"
        ? image
        : image?.url || image?.image || image?.src || "";

    return (
      <div className="file-item">
        <IconButton
          onClick={removeFile(image)}
          size="small"
          className="clear-btn"
          color="primary"
          component="span"
        >
          <ClearIcon />
        </IconButton>
        <img alt="img" src={imageSrc} className="file-img" />
      </div>
    );
  };
  // Return the list of files//
  return <section className="file-list">{renderImage(images)}</section>;
};

export default ImageGrid;